import {User01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {ComboboxItem} from '@/components/ui/combobox-atoms/ComboboxAtoms'
import {useGetUsers} from '@/features/users/queries/useGetUsers'
import {AgendaSidebarSearchList} from '@/features/agenda/components/agenda-sidebar-search/AgendaSidebarSearchList'

export const AgendaSidebarSearchUsersList = ({search, isQueryEnabled}: {search?: string; isQueryEnabled: boolean}) => {
    const {t} = useTranslation()

    const {
        data: users,
        isLoading,
        isError
    } = useGetUsers(
        {
            limit: 5,
            page: 1,
            search
        },
        undefined,
        {enabled: isQueryEnabled}
    )

    return (
        <AgendaSidebarSearchList
            isLoading={isLoading}
            isError={isError}
            items={users?.data}
            icon={<User01Icon size={15} />}
            labelText={t('commons:healthcare_professional', {count: 2})}
            renderItem={user => (
                <ComboboxItem
                    hasItemCheckbox
                    key={user.id}
                    value={user.id}
                    data-value={user.id}
                    data-source="users"
                    data-name={user.fullName}
                >
                    {user.fullName}
                </ComboboxItem>
            )}
        />
    )
}
